import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.section`
	background: ${palette('gradientCalmBrandDark')};
	color: ${palette('white')};
	overflow: hidden;
	padding: 40px 0;
	position: relative;
	text-align: center;

	${minWidth('tablet')} {
		padding: 80px 0 64px;
		text-align: left;
	}
`;

export const WelcomeText = styled(Text)`
	background: ${palette('white')};
	border-radius: 4px;
	grid-column: 1 / 4;
	margin-bottom: 16px;
	padding: 4px 16px;
	text-align: center;

	${minWidth('desktop')} {
		grid-column: 1 / 3;
		text-align: left;
	}
`;

export const Heading = styled.h1`
	font-size: 28px;
	${fontWeight(FontWeights.Regular)};
	grid-column: 1 / 4;
	margin-bottom: 40px;

	${minWidth('tablet')} {
		font-size: 49.5px;
		grid-column: 1 / 3;
	}
`;

export const ButtonWrapper = styled.div`
	grid-column: 1 / 3;
	margin-bottom: 48px;

	${minWidth('tablet')} {
		width: 75%;
	}

	${minWidth('desktop')} {
		grid-column: 1 / 2;
		width: 100%;
	}
`;

export const AppIcons = styled.div`
	bottom: 0;
	display: none;
	height: 100%;
	position: absolute;
	right: 0;
	width: 50%;

	${minWidth('tablet')} {
		display: block;
	}

	${minWidth('desktop')} {
		width: 40%;
	}
`;

export const RatingWrapper = styled.div`
	grid-column: 1 / 4;

	${minWidth('tablet')} {
		display: flex;
		grid-column: 1 / 3;
	}
`;

export const Users = styled.div`
	display: block;
	flex: 0 0 96px;
	margin: 0 auto 16px;

	${minWidth('tablet')} {
		margin: 0;
		margin-right: 16px;
	}
`;

export const RatingText = styled.p``;
